module.exports = __webpack_public_path__ + "static/images/arrow-chart-up.6833eb69b36f9de745a00f1c150e50f0.svg";